import React from 'react';
import { Box } from '@mui/material';
import { passportLayout } from '../../../design/passportTokens';

export default function PassportPageShell({ children, sx = {}, ...props }) {
  return (
    <Box
      component="main"
      className="passport-page-shell"
      sx={{
        flex: 1,
        width: '100%',
        maxWidth: 1120,
        mx: 'auto',
        px: { xs: 1, sm: 2, md: 3 },
        py: { xs: 2.5, md: 4 },
        boxSizing: 'border-box',
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        // Keep the final controls above the fixed mobile navigation and the
        // device safe area.
        pb: {
          xs: `calc(${passportLayout.mobileNavHeight + 16}px + env(safe-area-inset-bottom, 0px))`,
          md: '24px',
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
}
